import "./CheckBoxWithComponents.scss";

export function Checkbox({ text, checkBoxState, toggleCheckBox }) {
  return (
    <div className="checkbox-container">
      <label className="checkbox-wrapper">
        <input
          type="checkbox"
          className="hidden-checkbox"
          checked={checkBoxState}
          onChange={(ev) => {
            toggleCheckBox(ev.target.checked);
          }}
        />
        <span className="custom-checkbox" />
        {text}
      </label>
    </div>
  );
}
